import { gql } from 'apollo-boost';

// eslint-disable-next-line import/prefer-default-export
export const GET_RAISING_AND_FUND_INFORMATION = gql`
  query getRepurchaseAndFundInformation($repurchaseId: ID) {
    repurchase(id: $repurchaseId) {
      id
      classes {
        edges {
          node {
            id
            name
            state
          }
        }
      }
      valueFee
      valueFeeNominal
      targetCapitalIncrease
      valorizationDate
      initialParticipationOrderReceptionDate
      lastParticipationOrderReceptionDate
      initialFeePaymentDate
      lastFeePaymentDate
      dateEmissionFee
      initialFeeAdjudicationDate
      finalFeeAdjudicationDate
      repurchasewheelSet {
        edges {
          node {
            id
            dateInitial
            dateEnd
            dateAward
          }
        }
      }
      fund {
        id
        hasClasses
        businessName
        fundType
        minimumInvestment
        currency {
          code
          symbol
        }
        funddocumentSet {
          edges {
            node {
              fileType
              file
              date
              state
            }
          }
        }
      }
    }
  }
`;

export const GET_FUND = gql`
  query getFund($id: ID!) {
    fund(id: $id) {
      id
      hasClasses
    }
  }
`;

export const GET_CLIENT_BY_DOCUMENT_AND_RAISING = gql`
  query getClientByDocumentAndRepurchase(
    $repurchaseId: ID
    $documentNumber: String
    $documentType: String
  ) {
    getClientByDocumentAndRepurchase(
      repurchaseId: $repurchaseId
      documentNumber: $documentNumber
      documentType: $documentType
    ) {
      id
    }
  }
`;

export const SUBMIT_RAISING_PARTICIPATION = gql`
  mutation createParticipationRepurchase(
    $repurchaseId: ID
    $input: CreateParticipationInput
  ) {
    createParticipationRepurchase(repurchaseId: $repurchaseId, input: $input) {
      created
      response
    }
  }
`;

export const GET_MAX_FEE_COUNT = gql`
  query totalFundFeeCountRepurchase($repurchaseId: ID, $clientId: ID) {
    totalFundFeeCountRepurchase(
      repurchaseId: $repurchaseId
      clientId: $clientId
    ) {
      fundFeeCount
    }
  }
`;

export const GET_CLIENT_PARTICIPANT_FUNDS = gql`
  query getClientParticipantFunds($clientId: ID!) {
    listParticipant(client: $clientId) {
      edges {
        node {
          id
          state
          wheel {
            raising {
              number
              fund {
                id
                businessName
              }
            }
          }
        }
      }
    }
  }
`;
